var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
      attrs: { "data-active-cat": _vm.selectedCatIds }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized"
            }
          ]
        },
        [
          _c(
            "div",
            {
              staticClass: "mobile-close",
              on: {
                click: function($event) {
                  return _vm.closeNavigation()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-times" })]
          ),
          _vm._v(" "),
          _c(
            "lazy-load",
            { attrs: { component: "phywe-avatar-mobile" } },
            [_c("phywe-avatar-mobile", { attrs: { lang: _vm.Sprache } })],
            1
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 menu-active",
              attrs: { id: "menu-1" }
            },
            [
              _vm.dataContainer1.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer1.parent &&
                              _vm.dataContainer1.parent.parent) ||
                              null,
                            true
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "nav-direction d-flex align-items-center mHeader"
                        },
                        [
                          _vm.selectedCat
                            ? [
                                _c("i", {
                                  staticClass: "fa fa-long-arrow-left",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-fill text-center" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.selectedCat.details[0].name
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer1.categories, function(category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.getCategoryUrl(category.url) } },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function($event) {
                              return _vm.slideTo(category)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-lg fa-caret-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    : _vm._e()
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer1.categories[0]
                ? _vm._l(
                    _vm.dataContainer1.categories[0].siblingCount -
                      _vm.dataContainer1.categories.length,
                    function(number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" }
                        })
                      ])
                    }
                  )
                : _vm.dataContainer1.parent
                ? _vm._l(_vm.dataContainer1.parent.childCount, function(
                    number
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.breadcrumbs.length == 0
                ? [
                    _c("li", { staticClass: "ddown" }, [
                      _c("a", { attrs: { href: _vm.urlService } }, [
                        _c("img", {
                          attrs: {
                            src:
                              "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/service.svg",
                            width: "25"
                          }
                        }),
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$translate("Phywe::Template.serviceIconText")
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.bonusprogActive
                      ? _c(
                          "li",
                          {
                            staticClass: "ddown bonusprogramm-menu",
                            class: [
                              {
                                "bonusprogramm-special":
                                  _vm.bonusprogView === "special"
                              },
                              { loggedin: _vm.$store.getters.isLoggedIn }
                            ]
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "ml-0",
                                attrs: { href: _vm.bonusprogUrl }
                              },
                              [
                                (_vm.bonusprogView === "special"
                                ? _vm.$store.getters.isLoggedIn
                                : true)
                                  ? _c(
                                      "svg",
                                      {
                                        staticStyle: {
                                          "min-height": "25px",
                                          "min-width": "25px"
                                        },
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          height: "30px",
                                          viewBox: "0 -960 960 960",
                                          width: "30px",
                                          fill: "#929292"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          staticStyle: { fill: "#929292" },
                                          attrs: {
                                            d:
                                              "M480-80q-24 0-46-9t-39-26q-29-29-50-38t-63-9q-50 0-85-35t-35-85q0-42-9-63t-38-50q-17-17-26-39t-9-46q0-24 9-46t26-39q29-29 38-50t9-63q0-50 35-85t85-35q42 0 63-9t50-38q17-17 39-26t46-9q24 0 46 9t39 26q29 29 50 38t63 9q50 0 85 35t35 85q0 42 9 63t38 50q17 17 26 39t9 46q0 24-9 46t-26 39q-29 29-38 50t-9 63q0 50-35 85t-85 35q-42 0-63 9t-50 38q-17 17-39 26t-46 9Zm0-80q8 0 15.5-3.5T508-172q41-41 77-55.5t93-14.5q17 0 28.5-11.5T718-282q0-58 14.5-93.5T788-452q12-12 12-28t-12-28q-41-41-55.5-77T718-678q0-17-11.5-28.5T678-718q-58 0-93.5-14.5T508-788q-5-5-12.5-8.5T480-800q-8 0-15.5 3.5T452-788q-41 41-77 55.5T282-718q-17 0-28.5 11.5T242-678q0 58-14.5 93.5T172-508q-12 12-12 28t12 28q41 41 55.5 77t14.5 93q0 17 11.5 28.5T282-242q58 0 93.5 14.5T452-172q5 5 12.5 8.5T480-160Zm100-160q25 0 42.5-17.5T640-380q0-25-17.5-42.5T580-440q-25 0-42.5 17.5T520-380q0 25 17.5 42.5T580-320Zm-202-2 260-260-56-56-260 260 56 56Zm2-198q25 0 42.5-17.5T440-580q0-25-17.5-42.5T380-640q-25 0-42.5 17.5T320-580q0 25 17.5 42.5T380-520Zm100 40Z"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                  PHYWE Bonusprogramm\n                "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pid === "49091"
                      ? [
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(1) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu1"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(2) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu2"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(3) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu3"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ])
                        ]
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0",
              attrs: { id: "menu-2" }
            },
            [
              _vm.dataContainer2.parent
                ? _c(
                    "li",
                    {
                      staticClass: "ddown",
                      on: {
                        click: function($event) {
                          return _vm.slideTo(
                            (_vm.dataContainer2.parent &&
                              _vm.dataContainer2.parent.parent) ||
                              null,
                            true
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "nav-direction d-flex align-items-center mHeader"
                        },
                        [
                          _vm.selectedCat
                            ? [
                                _c("i", {
                                  staticClass: "fa fa-long-arrow-left",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-fill text-center" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.selectedCat.details[0].name
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataContainer2.categories, function(category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    { attrs: { href: _vm.getCategoryUrl(category.url) } },
                    [_vm._v(_vm._s(category.details[0].name))]
                  ),
                  _vm._v(" "),
                  category.childCount
                    ? _c(
                        "span",
                        {
                          staticClass: "nav-direction",
                          on: {
                            click: function($event) {
                              return _vm.slideTo(category)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-lg fa-caret-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    : _vm._e()
                ])
              }),
              _vm._v(" "),
              _vm.dataContainer2.categories[0]
                ? _vm._l(
                    _vm.dataContainer2.categories[0].siblingCount -
                      _vm.dataContainer2.categories.length,
                    function(number) {
                      return _c("li", { staticClass: "ddown" }, [
                        _c("span", {
                          staticClass: "nav-placeholder m-3",
                          style: { width: Math.random() * 20 + 60 + "%" }
                        })
                      ])
                    }
                  )
                : _vm.dataContainer2.parent
                ? _vm._l(_vm.dataContainer2.parent.childCount, function(
                    number
                  ) {
                    return _c("li", { staticClass: "ddown" }, [
                      _c("span", {
                        staticClass: "nav-placeholder m-3",
                        style: { width: Math.random() * 20 + 60 + "%" }
                      })
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.breadcrumbs.length == 0
                ? [
                    _c("li", { staticClass: "ddown" }, [
                      _c("a", { attrs: { href: _vm.urlService } }, [
                        _c("img", {
                          attrs: {
                            src:
                              "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/service.svg",
                            width: "25"
                          }
                        }),
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$translate("Phywe::Template.serviceIconText")
                            ) +
                            "\n                "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.pid === "49091"
                      ? [
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(1) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu1"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(2) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu2"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "ddown" }, [
                            _c("a", { attrs: { href: _vm.com(3) } }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Phywe::Template.comShopMenu3"
                                    )
                                  ) +
                                  "\n                  "
                              )
                            ])
                          ])
                        ]
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isNavigationInitialized
        ? [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c("li", {
                staticClass: "btn-close",
                on: {
                  click: function($event) {
                    return _vm.closeNavigation()
                  }
                }
              }),
              _vm._v(" "),
              _vm._m(0)
            ]),
            _vm._v(" "),
            _c("loading-animation")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("i", { staticClass: "fa fa-home", attrs: { "aria-hidden": "true" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }